/**
 * Predict ball Y at a vertical paddle line, reflecting top/bottom.
 * Used by a proper Pong AI (aim at intercept, not chase current Y).
 */
export function predictPaddleY(
  ball: { x: number; y: number; vx: number; vy: number },
  paddleX: number,
  courtTop: number,
  courtBot: number,
  ballR: number
): number | null {
  // Ball not moving toward this paddle.
  if (ball.vx === 0) return null
  if ((paddleX - ball.x) * ball.vx <= 0) return null

  let x = ball.x
  let y = ball.y
  let vx = ball.vx
  let vy = ball.vy
  const lo = courtTop + ballR
  const hi = courtBot - ballR

  for (let i = 0; i < 16; i++) {
    const tHit = (paddleX - x) / vx
    if (tHit < 0) return null

    let tWall = Infinity
    if (vy > 0.0001) tWall = (hi - y) / vy
    else if (vy < -0.0001) tWall = (lo - y) / vy

    if (tHit <= tWall || !Number.isFinite(tWall)) {
      return y + vy * tHit
    }

    // Bounce floor/ceiling, continue.
    x += vx * tWall
    y = vy > 0 ? hi : lo
    vy *= -1
  }
  return y
}
